import * as React from 'react';
import { translateBlock } from 'i18n';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { capitalize } from 'helpers/helpers';
import './_cellar.scss';
import { Link, useParams } from 'react-router-dom';
import { AvailableFunction, AvailableTable } from '../types';

const TableDetailsHeader = () => {
    const { func: domain, table } = useParams<{
        func: AvailableFunction;
        table?: AvailableTable;
    }>();
    return (
        <Breadcrumbs
            aria-label="breadcrumb"
            separator={
                <NavigateNextIcon
                    sx={{ display: { xs: 'none', sm: 'block' } }}
                />
            }
        >
            <Link className="breadcrumbs-link" to={`/cellar/${domain}`}>
                <Typography variant="h4" color="primary">
                    {capitalize(translateBlock(domain))}
                </Typography>
            </Link>
            <Typography variant="h4" color="primary">
                {capitalize(translateBlock(table))}
            </Typography>
        </Breadcrumbs>
    );
};

export default React.memo(TableDetailsHeader);
